module.exports = __webpack_public_path__ + "img/style11.b7f0baaa.png";